export default "__VITE_ASSET__DF02JM$2__"